import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { ChangeDetectorRef } from '@angular/core';

import {ToastsManager} from 'ng6-toastr';
import {HttpParams} from '@angular/common/http';
import {RequestsService} from '../services/requests.service';
import {AppConfig} from '../config/app.config';
import {GeneratSetting} from '../source/general_settings/generatSetting';
import {SharedService} from '../services/SharedService';
import {MessagingService} from '../services/messagingService';

@Component({
  selector: 'app-locking',
  templateUrl: './locking.component.html',
  styleUrls: ['./locking.component.css']
})
export class LockingComponent implements OnInit {
  constructor(private router: Router,
    public toastr: ToastsManager,
    private requestsService: RequestsService,
    private sharedService: SharedService,
    private cdr: ChangeDetectorRef,
    private messagingService: MessagingService) {
    
  }
  users:any;
  numpadInput: string = '';
  maskedOutput: string = '';
  selectedUser: any = null;
  showClockIn:boolean;
  showClockOut:boolean;
  showLogin:boolean;
  selectedUserId:any;
  selectedStore:boolean;
  selectedStoreId:any;
  stores:any;
  ClockIn:boolean;
  ClockOut:boolean;
  Errormsg : string = '';
  reset(){
    this.selectedUserId = 0;
     this.showClockIn = false;
    this.showClockOut = false;
    this.ClockIn = false;
    this.ClockOut = false;
    this.numpadInput = "";
    this.maskedOutput = "";

  }
  ngOnInit(): void {
    console.log('🔒 LockingComponent ngOnInit triggered');
    // this.get_clocked_out_users(0);
    this.showClockIn = false;
    this.showClockOut = false;
    this.ClockIn = false;
    this.ClockOut = false;
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        console.log('Navigation ended on Locking page:', event.url);
        
        // Any logic to run once navigation completes
        // e.g., force state updates, or refresh the component manually
      }
    });

    if (!window.localStorage.getItem(btoa('access_token')) || window.localStorage.getItem(btoa('access_token'))=='null' || window.localStorage.getItem(btoa('access_token'))==null) {
          this.router.navigate(['/login']);
     
    }else{
      // Login But Locked so we have to just login
      this.showClockOut = false;
      this.showClockIn = false;
      this.showLogin = true;
    }
    this.selectedStore = false;

     if (window.localStorage.getItem(btoa('selected_store'))){
      
      this.selectedStoreId = atob(window.localStorage.getItem(btoa('selected_store')));
      this.selectedStore = this.selectedStoreId;
      this.get_clocked_out_users(this.selectedStoreId);
    }else{
    this.getStores();

    }


  }

  
    getStores() {
      let body = new HttpParams();
      body = body.set('table', 'stores');
      // body = body.set('action', 'store_id');
  
      this.requestsService.postRequest('settings/fetch', body)
        .subscribe(
          (response: any[]) => {
            if (response) {
              if (response.length) {
                this.stores = response;
    

 
                console.log ("Stores Length"+this.stores.length);
                if (this.stores.length ==1){
                  this.selectedStore = this.stores[0].store_id;
                }
                
              }
            }
          }
        );
    }

  processLogin(){
    let body = new HttpParams();
    body = body.set('email', this.selectedUser.user_email);
    body = body.set('password', this.selectedUser.user_password);
    body = body.set('device_type', 'web');
    body = body.set('grantType', 'password');
    body = body.set('login_type', 'pin');


    return this.requestsService.postRequestauthToken('auth/token', body).subscribe((response: Response) => {

      if (response['result_type'] === 'Success') {
        if (response['token_data']['token_type'] === 'Bearer') {

          window.localStorage.setItem(btoa('access_token'), btoa(response['token_data']['access_token']));
          window.localStorage.setItem(btoa('expire_in'), btoa(response['token_data']['expires_in']));
          window.localStorage.setItem(btoa('token_type'), btoa(response['token_data']['token_type']));
          window.localStorage.setItem(btoa('user'), btoa(JSON.stringify(response['user_data'])));
          window.localStorage.setItem(btoa('multi_stores'), btoa(JSON.stringify(response['stores_info']['multi_stores'])));
          window.localStorage.setItem(btoa('store_count'), btoa(JSON.stringify(response['stores_info']['count'])));
         // this.user_id = response['user_data'].user_id;
          if (response['store_data'] != '') {
            window.localStorage.setItem(btoa('store_data'), btoa(JSON.stringify(response['store_data'])));
            window.localStorage.setItem(btoa('store_order_number'), btoa(JSON.stringify(response['store_data']['current_store_order_number'])));
            window.localStorage.setItem(btoa('original_store_order_number'), btoa(JSON.stringify(response['store_data']['store_order_number'])));
           // this.store_id = response['store_data'].store_id;
          }
          if (response['register'] != '') {
            window.localStorage.setItem(btoa('register'), btoa(JSON.stringify(response['register'])));
          }
          if (response['general_settings'] != '') {
            window.localStorage.setItem(btoa('general_settings'), btoa(unescape(encodeURIComponent(JSON.stringify(response['general_settings'])))));
          }
          if (response['features_detail'] != '') {
            window.localStorage.setItem(btoa('features_detail'), btoa(unescape(encodeURIComponent(JSON.stringify(response['features_detail'])))));
          }
          if (response['user_permission'] != '') {
            window.localStorage.setItem(btoa('user_permission'), btoa(JSON.stringify(response['user_permission'])));
          } else {
            var permission = [];
            window.localStorage.setItem(btoa('user_permission'), btoa(JSON.stringify(permission)));
          }
          window.localStorage.setItem("screen_locked","0");
          if (this.selectedUser.logged_in=="1"){
            window.localStorage.setItem(btoa('clocktime'), btoa(this.selectedUser.last_login));
             
          }



          this.router.navigate(['/home']);
        //  this.requestPermissionForToken(this.user_id, this.store_id);
        
        }
      } 
    });


  }

  selectStore(store:any){
    window.localStorage.setItem(btoa('time_zone'), btoa(store.store_timezone));
    this.selectedStoreId = store.store_id;
    this.get_clocked_out_users(store.store_id);
     window.localStorage.setItem(btoa('selected_store'), btoa(store.store_id));


  }




  timeClock() {
    let body = new HttpParams();
    body = body.set('user_id', this.selectedUser.user_id);

    return this.requestsService.clockTime(body).subscribe((response: Response) => {
      // console.log('time check',response);
      if (response['result_type'] === 'Success') {
        this.get_clocked_out_users(this.selectedStoreId);
        if (response['clocktime_in'] == 'time_in') {

          window.localStorage.setItem(btoa('clocktime'), btoa(response['clocktime']));
          window.localStorage.setItem(btoa('time_zone'), btoa(response['time_zone']));
          setInterval(() => {
           // this.sifttime = this.requestsService.getClockTime();
          }, 1000);
         // this.status = false;
         // this.toastr.success(response['message'], response['result_type']);
        } else {
          window.localStorage.removeItem(btoa('clocktime'));
          window.localStorage.removeItem(btoa('time_zone'));
          //this.status = true;
         // this.toastr.success('Checked out successfully', response['result_type']);
        }
        
        // this.toastr.success(response['message'], response['result_type']);
      } else {
        this.toastr.error(response['message'], response['result_type']);
      }
    });


  }

  login (state:any){
    // alert (this.selectedUser.user_pin);
   if (this.numpadInput == this.selectedUser.user_pin){
      this.Errormsg = "";
    switch (state){
      case -1:
        this.processLogin();
        break;
        case 1:
          this.timeClock();
          this.processLogin();
          
        break;
        case 0:
          this.timeClock();
          this.processLogin();
        break;
        case 2:
           this.timeClock();
          // this.router.navigate(['/locking']);
        break;
        case 3:
           this.timeClock();
           //this.router.navigate(['/locking']);
        break;
       
    }
    //  this.get_clocked_out_users(this.selectedStoreId);
    this.reset();
    
   
  }else{
      this.Errormsg = " Invalid Pin";
      this.numpadInput = '';
      this.maskedOutput = "";
   }
  }


  selectUser(user: any) {
    console.log (user);
    this.selectedUser = user;
    this.selectedUserId = user.user_id;

    if (user.attendance=='1'){
      this.showLogin = true;
      this.showClockIn = false;
      this.showClockOut = false;
      this.ClockIn = false;
      this.ClockOut = false;
    }else if (user.attendance =='2'){
      // Login and Clock IN/Out Case 

      this.showLogin = true;
    //  this.showClockIn = true;
     // this.showClockOut = true;
      this.ClockIn = true;
      this.ClockOut = true;

   if (user.logged_in=='1'){
      this.ClockIn = false;
      }else{      
      this.ClockOut = false;
      }


      
    }else if (user.attendance =='3'){
      // Clock IN / Out Only 

      this.showLogin = false;
      this.showClockIn = false;
      this.showClockOut = false;
      this.ClockIn = true;
      this.ClockOut = true;

      // Check if User is already clocked in then show clock out else show Clock In 

      if (user.logged_in=='1'){
      this.ClockIn = false;
      this.ClockOut = true;
  
      }else{
        this.ClockIn = true;
      this.ClockOut = false;

      }



    }











//     if (user.logged_in=='1'){
//       this.showClockOut = true;
//       this.showClockIn = false;
//     }else{
//       this.showClockOut = false;
//       this.showClockIn = true;
//     }

    

//     if (!window.localStorage.getItem(btoa('access_token')) || window.localStorage.getItem(btoa('access_token'))=='null' || window.localStorage.getItem(btoa('access_token'))==null) {
    
//     if (user.attendance =="2"){
//       this.showLogin = true;
//     }else if (user.attendance =="3"){
//       this.showLogin = false;
//     }else{
//       this.showLogin = true;
//       this.showClockOut = false;
//       this.showClockIn = false;
//     }
    
//     }else{

//       if (window.localStorage.getItem(btoa('clocktime'))) {
//           // Login and Clocked IN just show login button
//         this.showLogin = true;
        
//       }else{
//         // Login but not clocked IN 
//  if (user.logged_in=='1'){
//       this.showClockOut = true;
//       this.showClockIn = false;
//     }else{
//       this.showClockOut = false;
//       this.showClockIn = true;
//     }

//       }


//       // Login But Locked so we have to just login
     
//     }

  }
  logout(){
    this.router.navigate(['./logout']);


  }
  get_clocked_out_users(store_id:any) {

    let body = new HttpParams();
  
    this.requestsService.getSettingsRequest('auth/users_clocked/'+store_id).subscribe((response: any) => {
      console.log('Response snapshot:', JSON.parse(JSON.stringify(response)));

        if (response['result_type'] === 'Success') {
          // this.users = response['users'];
          this.users = [...response['users']];          
          this.selectedStore = store_id;
          this.cdr.detectChanges(); // Force view update

        }
      }, error => {
      },
      () => {
      

      }
    );

  }


  addChar(char: string): void {
     this.Errormsg = "";
    if (this.numpadInput.length < 5) {
      this.numpadInput += char;
      this.updateMaskedOutput();
    }
  }

  clearInput(): void {
    this.numpadInput = '';
    this.updateMaskedOutput();
  }

  backspaceChar(): void {
    this.numpadInput = this.numpadInput.slice(0, -1);
    this.updateMaskedOutput();
  }

  updateMaskedOutput(): void {
    this.maskedOutput = this.numpadInput.length > 0
      ? '*'.repeat(this.numpadInput.length)
      : '';
  }



}
